var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23279 2.31982H6.88093C3.50128 2.31982 2.14941 3.67169 2.14941 7.05134V11.1069C2.14941 14.4866 3.50128 15.8384 6.88093 15.8384H10.9365C14.3162 15.8384 15.668 14.4866 15.668 11.1069V9.75506",
    stroke: "#272121",
    strokeWidth: 1.08149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6398 3.00917L6.31349 8.3355C6.11071 8.53828 5.90793 8.93708 5.86738 9.22773L5.57673 11.2623C5.46858 11.999 5.98905 12.5128 6.72581 12.4114L8.76036 12.1207C9.04425 12.0802 9.44305 11.8774 9.65259 11.6746L14.9789 6.34826C15.8982 5.429 16.3308 4.36103 14.9789 3.00917C13.6271 1.6573 12.5591 2.0899 11.6398 3.00917Z",
    stroke: "#272121",
    strokeWidth: 1.08149,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.876 3.77295C11.1001 4.56884 11.5249 5.29384 12.1095 5.8785C12.6942 6.46317 13.4192 6.88791 14.2151 7.11205",
    stroke: "#272121",
    strokeWidth: 0.901241,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.466b4c6cad8077e6e9bb3ed24e7fa270.svg";
export { ForwardRef as ReactComponent };